import { render, staticRenderFns } from "./OfficeTeam.vue?vue&type=template&id=2a138048&scoped=true"
import script from "./OfficeTeam.vue?vue&type=script&lang=js"
export * from "./OfficeTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a138048",
  null
  
)

export default component.exports